export const HEALTH_CONCERNS = [
  "Anorexia",
  "ARFID",
  "Binge Eating",
  "Bulimia",
  "Cancer",
  "Celiac",
  "CSID",
  "Diabetes",
  "Disordered Eating/Bettering Your Relationship With Food",
  "Diverticulosis/litis",
  "Dutch Testing",
  "Dysphagia",
  "Eating Disorders",
  "Emotional Eating",
  "Eosinophilic Esophagitis (EoE)",
  "Fatty Liver Disease",
  "Food Allergies",
  "Food Intolerances",
  "Gallbladder Issues",
  "Gastritis",
  "Gastroparesis",
  "General Health",
  "GERD",
  "Gestational Diabetes",
  "GI maps",
  "Gut Health",
  "Hormonal Imbalance",
  "IBD/Crohn's",
  "IBS",
  "Infertility",
  "Intuitive Eating/HAES Approach",
  "Kidney Disease",
  "Lowering Blood Pressure",
  "Lowering Cholesterol",
  "Low FODMAP",
  "Lyme Disease",
  "Menopause",
  "Mold Toxicity",
  "Orthorexia",
  "Pancreatitis",
  "PMOS (formerly PCOS)",
  "Pediatrics",
  "Picky Eaters",
  "Post OP Care for Bariatric Surgery",
  "Pre-diabetes",
  "Pre OP Clearance for Bariatric Surgery",
  "Prenatal/Postpartum Care",
  "SIBO",
  "Sports Nutrition",
  "Thyroid Disorders",
  "TPN",
  "Tube Feeds",
  "Vegan/Vegetarian",
  "Weight Gain",
  "Weight Loss",
  "Weight Management",
];

export enum INSURANCE_FORM_STEPS {
  PROVIDER = "provider",
  OTHER_INSURANCE = "otherInsurance",
  PLAN_TYPE_PROVIDER = "planTypeProvider",
  MEDICAL_CONDITIONS = "medicalConditions",
  PLAN_COVERAGE = "planCoverage",
  BCBS_PLAN = "bcbsPlan",
  ANTHEM_EMPIRE_POS = "anthemEmpirePos",
  UHC_PLAN = "uhcPlan",
  AETNA_PLAN = "aetnaPlan",
  FIDELIS_PLAN = "fidelisPlan",
  MEMBER_ID_FORM = "memberIdForm",
}

export const LIMITED_PLAN_COVERAGES = ["HMO", "PPO"];

export const MARTINS_POINT_INSURANCE_PROVIDER = "Martins Point";

export enum INSURANCE_PROVIDERS {
  aetna = "Aetna",
  bcbs = "BCBS",
  cdphp = "CDPHP",
  cigna = "Cigna",
  curative = "Curative",
  empireNyship = "Empire NYSHIP",
  fidelis = "Fidelis",
  firstHealth = "First Health",
  harvardPilgrim = "Harvard Pilgrim",
  independentHealth = "Independent Health",
  martinsPoint = "Martin's Point",
  medigold = "Medigold",
  meritain = "Meritain",
  mvp = "MVP",
  nysMedicaid = "NYS Medicaid",
  trinityMedicare = "Trinity Medicare",
  uhc = "UHC",
  umr = "UMR",
  univera = "Univera",
  upmc = "UPMC",
  wellpoint = "Wellpoint",
  emblemHealth = "EmblemHealth",
  traditionalMedicare = "Traditional Medicare",
  humanaMedicare = "Humana Medicare",
  other = "Other",
}

export enum PLAN_TYPE_PROVIDERS {
  medicare = "Medicare",
  medicaid = "Medicaid",
  employer = "Employer",
  CHP = "CHP",
  HARP = "HARP",
  essentialPlan = "Essential Plan",
}

// UPMC - Medicare and Employer only (no Medicaid)
export enum UPMC_PLAN_TYPE_PROVIDERS {
  medicare = "Medicare",
  employer = "Employer",
}

// Trinity Medicare - Medicare only
export enum TRINITY_MEDICARE_PLAN_TYPE_PROVIDERS {
  medicare = "Medicare",
}

// Harvard Pilgrim - Medicare and Employer only (Medicare goes to Private Practice)
export enum HARVARD_PILGRIM_PLAN_TYPE_PROVIDERS {
  medicare = "Medicare",
  employer = "Employer",
}

// Wellpoint - Medicaid, CHP, HARP, Essential Plan
export enum WELLPOINT_PLAN_TYPE_PROVIDERS {
  medicaid = "Medicaid",
  CHP = "CHP",
  HARP = "HARP",
  essentialPlan = "Essential Plan",
}

// Fidelis - Include CHP option
export enum FIDELIS_PLAN_TYPE_PROVIDERS {
  medicare = "Medicare",
  medicaid = "Medicaid",
  CHP = "CHP",
}

export const MAX_HEALTH_CONDITIONS = 4;

export const NONE_OF_THESE = "None of these";

export const INSURANCE_MEDICAL_CONDITIONS = [
  "Diabetes",
  "Renal Disease",
  "Obesity",
  NONE_OF_THESE,
];

export const BCBS_PLANS = [
  "Anthem",
  "Empire",
  "Excellus",
  "Highmark WNY", // UPDATED - was just "Highmark"
  "Highmark NENY", // NEW
  "Highmark PA",
  "Other",
];

export const FIDELIS_MEDICAID_PLANS = [
  { label: "Essential", value: "Fidelis Essential" },
  { label: "Medicaid", value: "Fidelis Medicaid" },
];

export const FIDELIS_MEDICARE_PLANS = [
  { label: "Medicare", value: "Fidelis Medicare" },
  { label: "Dual Access", value: "Fidelis Dual Access" },
];

export const FIDELIS_CHP_PLANS = [{ label: "Medicaid", value: "Fidelis CHP" }];

export const PLAN_COVERAGES = ["HMO", "PPO", "EPO"];
export const BCBS_EMPLOYER_PLAN_COVERAGES = ["HMO", "PPO", "EPO"];
export const AETNA_PLAN_COVERAGES = ["HMO", "PPO"]; // NEW
export const FIDELIS_MEDICARE_PLAN_COVERAGES = [
  "Fidelis Medicare",
  "Fidelis Dual Access",
];
export const FIDELIS_MEDICAID_PLAN_COVERAGES = [
  "Fidelis Medicaid",
  "Fidelis Essential",
];

export const UHC_PLAN_COVERAGE_MEDICAID = {
  "UHC Community": "UHC Community",
  "UHC Dual Complete": "UHC Dual Complete",
} as const;

export const UHC_PLAN_COVERAGE_MEDICARE = {
  "UHC Medicare Advantage": "UHC Medicare Advantage",
  "UHC Dual Complete": "UHC Dual Complete",
} as const;

export const UPMC_PLAN_COVERAGES = ["HMO", "PPO"];
export const TRINITY_MEDICARE_PLAN_COVERAGES = ["HMO", "PPO"];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const VIDEO_CALL_LOCATION = "Healthie Video Call";

export const NEW_YORK_STATE = "New York";

export const LOCATION_OPTIONS = [
  "Albany",
  "Buffalo",
  "Syracuse",
  "Rochester",
  "Healthie Video Call",
];

export enum LOCATION_FORM_STEPS {
  STATE = "state",
  VISIT_TYPE_PREFERENCE = "visitTypePreference",
  OFFICE_PREFERENCE = "officePreference",
}

export const US_STATES: { value: string; label: string }[] = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DC", label: "District Of Columbia" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const VISIT_TYPES = ["In-person", "Telehealth"];

export const NEW_YORK_OFFICES = [
  {
    value: "Syracuse",
    label: "Syracuse Office - 5100 West Genesee Street Camillus, NY 13031",
  },
  {
    value: "Rochester",
    label:
      "Rochester Office - 1160K Pittsford-Victor Road, 2nd Floor #4, Pittsford NY 14534",
  },
  {
    value: "Buffalo",
    label: "Buffalo Office - 5360 Genesee Street, Lancaster, NY 14026",
  },
  {
    value: "Albany",
    label: "Albany Office - 125 Wolf Road Suite 212 Albany, NY 12205",
  },
];

export enum REFERRED_BY_VALUES {
  doctorOrHealthcareProvider = "Doctor or Healthcare Provider",
  FriendOrFamilyMember = "Friend/Family Member",
  worksiteOrEmployer = "Worksite/Employer",
  socialMedia = "Social Media",
  googleOrInternet = "Google/Internet",
  other = "Other",
}
